module.exports = __webpack_public_path__ + "img/IMG_2502-2.9ada98ee.jpg";